import BreakdownModel from "./BreakdownModel";

export default class FullnessProfile {
    public totalPercentage: number;
    public breakdown: BreakdownModel = new BreakdownModel();
}